<div *ngIf="isLoaded" class="customer-container">
  <!-- Header -->
  <div class="header">
    <div class="breadcrumbs">
      <button class="action-btn secondary-btn icon-btn" (click)="navigateBack()">
        <span class="icon">
          <img src="assets/icones/close_icon.svg" alt="" />
        </span>
      </button>
      <span>
        <div class="breadcrumb-item">{{ "companies.companies_name" | translate }}</div>
      </span>
      <img src="assets/icones/arrow_to_right.svg" alt="" />
      <span class="customer-name">{{ customer?.name }}</span>
    </div>

    <div class="header-actions">
      <ng-container *appHasPermission="{ module: 'company', action: 'delete' }">
        <ui-button
          *ngIf="!customer?.is_deleted"
          type="danger"
          icon="trash-cc"
          [label]="'common.archive' | translate"
          (click)="deleteCompany()">
        </ui-button>
      </ng-container>
      <ng-container *appHasPermission="{ module: 'company', action: 'edit' }">
        <ui-button
          *ngIf="customer?.is_deleted"
          type="secondary"
          icon="restore"
          [label]="'common.restore' | translate"
          (click)="restoreCompany()">
        </ui-button>
      </ng-container>
    </div>
  </div>

  <!-- Main content: shown when currentForm === 'recapCatalog' (default view).
       currentForm switches to 'editCatalog' when the catalog assignment sub-view is open. -->
  <div class="customer-content" *ngIf="currentForm === 'recapCatalog'">
    <!-- Left Panel (Tabs: Orders, Preference, Activity, Product) -->
    <div class="left-panel">
      <div class="tabs">
        <div class="tab" [class.active]="activeTab === 'orders'" (click)="activeTab = 'orders'">
          {{ 'customers.tabs.orders' | translate }}
        </div>
        <div class="tab" [class.active]="activeTab === 'product'" (click)="activeTab = 'product'">
          {{ 'customers.tabs.product' | translate }}
        </div>
        <div class="tab" [class.active]="activeTab === 'preference'" (click)="activeTab = 'preference'">
          {{ 'customers.tabs.preference' | translate }}
        </div>
        <div class="tab" [class.active]="activeTab === 'activity'" (click)="activeTab = 'activity'">
          {{ "customers.tabs.activity" | translate }}
        </div>
        <div class="tab" [class.active]="activeTab === 'location'" (click)="activeTab = 'location'">
          {{ 'customers.tabs.location' | translate }}
        </div>
      </div>

      <div class="tab-content-wrapper">
        <!-- Orders Tab -->
        <!-- Orders Tab — delegated to LocationOrdersTabComponent (H2 refactor) -->
        <app-location-orders-tab
          *ngIf="activeTab === 'orders'"
          [customer]="customer">
        </app-location-orders-tab>

        <!-- Product Tab -->
        <ng-container *ngIf="activeTab === 'product'">
          <div class="prd-container">

            <!-- ===== Favorite Products ===== -->
            <div class="prd-section">
              <div class="prd-section-header">
                <span class="prd-section-title">{{ 'customers.product_tab.favorite_products' | translate }}</span>
                <div class="prd-view-group">
                  <span class="prd-view-label">{{ 'customers.product_tab.view_label' | translate }}</span>
                  <button class="prd-view-btn"
                          [matMenuTriggerFor]="productLocationMenu"
                          (menuOpened)="onLocationMenuOpened()"
                          type="button">
                    <app-svg-icon svgIcon="filter-cc" class="prd-view-icon"></app-svg-icon>
                    <span>
                      <ng-container *ngIf="productLocationId === 'all'">
                        {{ 'companies.orders_tab.all_locations' | translate }}
                      </ng-container>
                      <ng-container *ngIf="productLocationId !== 'all'">
                        {{ getProductLocationName(productLocationId) }}
                      </ng-container>
                    </span>
                  </button>
                  <mat-menu #productLocationMenu="matMenu" class="ord-view-menu">
                    <div class="ord-view-menu-header">
                      <button mat-menu-item type="button"
                              (click)="onProductLocationChange('all')"
                              [class.active]="productLocationId === 'all'">
                        {{ 'companies.orders_tab.all_locations' | translate }}
                      </button>
                    </div>
                    <div class="ord-view-menu-list">
                      <button mat-menu-item type="button"
                              *ngFor="let loc of (customer.locations || [])"
                              (click)="onProductLocationChange(loc.id!)"
                              [class.active]="productLocationId === loc.id">
                        {{ loc.name }}
                      </button>
                    </div>
                  </mat-menu>
                </div>
              </div>

              <div class="prd-table-wrapper">
                <div class="prd-table-header prd-products-header">
                  <div class="prd-th-product-group">
                    <span class="prd-th prd-th-img">{{ 'customers.product_tab.img_header' | translate }}</span>
                    <span class="prd-th prd-th-name">{{ 'customers.product_tab.product_name_header' | translate }}</span>
                  </div>
                  <div class="prd-th prd-th-units prd-sortable" (click)="sortFavoriteProducts('total_units')">
                    <span>{{ 'common.units' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-orders prd-sortable" (click)="sortFavoriteProducts('total_orders')">
                    <span>{{ 'customers.tabs.orders' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-revenue prd-sortable" (click)="sortFavoriteProducts('total_revenue')">
                    <span>{{ 'customers.product_tab.revenue_header' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-lastord prd-sortable" (click)="sortFavoriteProducts('last_ordered')">
                    <span>{{ 'customers.product_tab.last_ordered_header' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                </div>

                <div class="prd-table-body">
                <!-- Products: populated -->
                <ng-container *ngIf="productFavoritesProducts.length > 0; else productsEmpty">
                  <div class="prd-row" *ngFor="let product of productFavoritesProducts">
                    <div class="prd-cell-product">
                      <div class="prd-product-img">
                        <img [src]="product.image || 'assets/icones/default-image-product.svg'" alt="" />
                      </div>
                      <div class="prd-product-info">
                        <span class="prd-product-name">{{ product.product_name || '--' }}</span>
                        <span class="prd-product-code">{{ product.product_code || '--' }}</span>
                      </div>
                    </div>
                    <div class="prd-cell prd-cell-units">
                      <span class="prd-cell-main">{{ product.total_units | number }}</span>
                    </div>
                    <div class="prd-cell prd-cell-orders">
                      <span class="prd-cell-main">{{ product.total_orders | number }}</span>
                    </div>
                    <div class="prd-cell prd-cell-revenue">
                      <span class="prd-cell-main">{{ product.total_revenue | number:'1.2-2' }} €</span>
                    </div>
                    <div class="prd-cell prd-cell-lastord">
                      <span class="prd-cell-main">{{ product.last_ordered ? (product.last_ordered | date: DATE_FORMAT) : '--' }}</span>
                    </div>
                  </div>
                </ng-container>

                <!-- Products: empty -->
                <ng-template #productsEmpty>
                  <div class="prd-empty-body">
                    <img src="assets/icones/no-product-illustration.svg" alt="" class="prd-empty-illustration" />
                    <p class="prd-empty-text">{{ 'companies.orders_tab.not_enough_data' | translate }}</p>
                  </div>
                </ng-template>
              </div>
              </div>
            </div>

            <!-- ===== Favorite Brands ===== -->
            <div class="prd-section">
              <div class="prd-section-header">
                <span class="prd-section-title">{{ 'customers.product_tab.favorite_brands' | translate }}</span>
              </div>

              <div class="prd-table-wrapper">
                <div class="prd-table-header prd-metric-header">
                  <div class="prd-th prd-th-metric-name prd-sortable">
                    <span>{{ 'customers.product_tab.brand_header' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-metric-units prd-sortable">
                    <span>{{ 'common.units' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-metric-orders prd-sortable">
                    <span>{{ 'customers.tabs.orders' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-metric-revenue prd-sortable">
                    <span>{{ 'customers.product_tab.revenue_header' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                </div>

              <div class="prd-table-body">
                <!-- Brands: populated -->
                <ng-container *ngIf="productFavoritesBrands.length > 0; else brandsEmpty">
                  <div class="prd-row prd-metric-row" *ngFor="let brand of productFavoritesBrands">
                    <div class="prd-cell prd-cell-metric-name">
                      <span class="prd-cell-main">{{ brand.brand_name || '--' }}</span>
                    </div>
                    <div class="prd-cell prd-cell-metric-units">
                      <span class="prd-cell-main">{{ brand.total_units | number }}</span>
                    </div>
                    <div class="prd-cell prd-cell-metric-orders">
                      <span class="prd-cell-main">{{ brand.total_orders | number }}</span>
                    </div>
                    <div class="prd-cell prd-cell-metric-revenue">
                      <span class="prd-cell-main">{{ brand.total_revenue | number:'1.2-2' }} €</span>
                    </div>
                    <!-- <div class="prd-cell prd-cell-metric-bar">
                      <div class="prd-progress-track">
                        <div class="prd-progress-fill" [style.width.%]="10"></div>
                      </div>
                      <span class="prd-progress-label">--</span>
                    </div> -->
                  </div>
                </ng-container>

                <!-- Brands: empty -->
                <ng-template #brandsEmpty>
                  <div class="prd-empty-body">
                    <img src="assets/icones/no-product-illustration.svg" alt="" class="prd-empty-illustration" />
                    <p class="prd-empty-text">{{ 'companies.orders_tab.not_enough_data' | translate }}</p>
                  </div>
                </ng-template>
              </div>
              </div>
            </div>

            <!-- ===== Favorite Categories ===== -->
            <div class="prd-section">
              <div class="prd-section-header">
                <span class="prd-section-title">{{ 'customers.product_tab.favorite_categories' | translate }}</span>
              </div>

              <div class="prd-table-wrapper">
                <div class="prd-table-header prd-metric-header">
                  <div class="prd-th prd-th-metric-name prd-sortable">
                    <span>{{ 'customers.product_tab.category_header' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-metric-units prd-sortable">
                    <span>{{ 'common.units' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-metric-orders prd-sortable">
                    <span>{{ 'customers.tabs.orders' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                  <div class="prd-th prd-th-metric-revenue prd-sortable">
                    <span>{{ 'customers.product_tab.revenue_header' | translate }}</span>
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prd-sort-icon" />
                  </div>
                </div>

              <div class="prd-table-body">
                <!-- Categories: populated -->
                <ng-container *ngIf="productFavoritesCategories.length > 0; else categoriesEmpty">
                  <div class="prd-row prd-metric-row" *ngFor="let category of productFavoritesCategories">
                    <div class="prd-cell prd-cell-metric-name">
                      <span class="prd-cell-main">{{ category.category_name || '--' }}</span>
                    </div>
                    <div class="prd-cell prd-cell-metric-units">
                      <span class="prd-cell-main">{{ category.total_units | number }}</span>
                    </div>
                    <div class="prd-cell prd-cell-metric-orders">
                      <span class="prd-cell-main">{{ category.total_orders | number }}</span>
                    </div>
                    <div class="prd-cell prd-cell-metric-revenue">
                      <span class="prd-cell-main">{{ category.total_revenue | number:'1.2-2' }} €</span>
                    </div>
                  </div>
                </ng-container>

                <!-- Categories: empty -->
                <ng-template #categoriesEmpty>
                  <div class="prd-empty-body">
                    <img src="assets/icones/no-product-illustration.svg" alt="" class="prd-empty-illustration" />
                    <p class="prd-empty-text">{{ 'companies.orders_tab.not_enough_data' | translate }}</p>
                  </div>
                </ng-template>
              </div>
              </div>
            </div>

          </div>
        </ng-container>

        <!-- Preference Tab -->
        <ng-container *ngIf="activeTab === 'preference'">
          <div class="prt-container">

            <!-- ===== Available Catalogs ===== -->
            <div class="prt-section">
              <div class="prt-section-header">
                <span class="prt-section-title">{{ 'customers.preference_tab.available_catalogs' | translate }}</span>
                <button class="prd-view-btn"
                        [matMenuTriggerFor]="prefLocationMenu"
                        (menuOpened)="onLocationMenuOpened()"
                        type="button">
                  <app-svg-icon svgIcon="filter-cc" class="prd-view-icon"></app-svg-icon>
                  <span>
                    <ng-container *ngIf="preferenceLocationId === 'all'">
                      {{ 'companies.orders_tab.all_locations' | translate }}
                    </ng-container>
                    <ng-container *ngIf="preferenceLocationId !== 'all'">
                      {{ getPreferenceLocationName(preferenceLocationId) }}
                    </ng-container>
                  </span>
                  <mat-icon class="ord-view-caret">expand_more</mat-icon>
                </button>
                <mat-menu #prefLocationMenu="matMenu" class="ord-view-menu">
                  <div class="ord-view-menu-header">
                    <button mat-menu-item type="button"
                            (click)="onPreferenceLocationChange('all')"
                            [class.active]="preferenceLocationId === 'all'">
                      {{ 'companies.orders_tab.all_locations' | translate }}
                    </button>
                  </div>
                  <div class="ord-view-menu-list">
                    <button mat-menu-item type="button"
                            *ngFor="let loc of (customer.locations || [])"
                            (click)="onPreferenceLocationChange(loc.id!)"
                            [class.active]="preferenceLocationId === loc.id">
                      {{ loc.name }}
                    </button>
                  </div>
                </mat-menu>
              </div>
              <div class="prt-toolbar">
                <ui-form-field
                  class="prt-search-box"
                  type="text"
                  [prefixIcon]="'search'"
                  [placeholder]="'companies.search_catalog_placeholder' | translate"
                  [formControl]="catalogSearchInput"
                ></ui-form-field>
              </div>
              <div class="prt-table-wrapper">
                <div class="prt-table-header prt-catalog-grid">
                  <div class="prt-th prt-th-checkbox"><mat-checkbox></mat-checkbox></div>
                  <div class="prt-th prt-th-img">{{ 'customers.product_tab.img_header' | translate }}</div>
                  <div class="prt-th prt-th-name prt-sortable" (click)="sortTable('catalogs', 'catalog_name')">
                    {{ 'customers.preference_tab.catalog_name_header' | translate }}
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prt-sort-icon"
                      [class.prt-sort-asc]="sortState.catalogs?.column === 'catalog_name' && sortState.catalogs?.direction === 'asc'"
                      [class.prt-sort-desc]="sortState.catalogs?.column === 'catalog_name' && sortState.catalogs?.direction === 'desc'" />
                  </div>
                  <div class="prt-th prt-th-orders prt-sortable" (click)="sortTable('catalogs', 'total_orders')">
                    {{ 'customers.tabs.orders' | translate }}
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prt-sort-icon"
                      [class.prt-sort-asc]="sortState.catalogs?.column === 'total_orders' && sortState.catalogs?.direction === 'asc'"
                      [class.prt-sort-desc]="sortState.catalogs?.column === 'total_orders' && sortState.catalogs?.direction === 'desc'" />
                  </div>
                  <div class="prt-th prt-th-units prt-sortable" (click)="sortTable('catalogs', 'total_units')">
                    {{ 'common.units' | translate }}
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prt-sort-icon"
                      [class.prt-sort-asc]="sortState.catalogs?.column === 'total_units' && sortState.catalogs?.direction === 'asc'"
                      [class.prt-sort-desc]="sortState.catalogs?.column === 'total_units' && sortState.catalogs?.direction === 'desc'" />
                  </div>
                  <div class="prt-th prt-th-status prt-sortable" (click)="sortTable('catalogs', 'status')">
                    {{ 'common.status' | translate }}
                    <img src="assets/icones/sort-arrows.svg" alt="" class="prt-sort-icon"
                      [class.prt-sort-asc]="sortState.catalogs?.column === 'status' && sortState.catalogs?.direction === 'asc'"
                      [class.prt-sort-desc]="sortState.catalogs?.column === 'status' && sortState.catalogs?.direction === 'desc'" />
                  </div>
                </div>
                <div class="prt-table-body">
                  <ng-container *ngIf="filteredAvailableCatalogs.length > 0; else emptyCatalogs">
                    <div class="prt-table-row prt-catalog-grid" *ngFor="let row of filteredAvailableCatalogs" [class.prt-row-expired]="expired(row)">
                      <div class="prt-td prt-td-checkbox"><mat-checkbox></mat-checkbox></div>
                      <div class="prt-td prt-td-img">
                        <img class="listing_image no-image"
                             [src]="row.image || 'assets/icones/default-image-product.svg'"
                             (error)="onImageError($event)"
                             alt="" />
                      </div>
                      <div class="prt-td prt-td-name">
                        <span class="prt-catalog-name" (click)="editCatalog(row)">{{ row.catalog_name }}</span>
                        <span class="prt-catalog-id">{{ row.catalog_id ? 'OP-' + row.catalog_id : '' }}</span>
                      </div>
                      <div class="prt-td prt-td-orders">
                        <span class="prt-orders-count">{{ row.total_orders | number }}</span>
                      </div>
                      <div class="prt-td prt-td-units">
                        <span class="prt-orders-count">{{ row.total_units | number }}</span>
                      </div>
                      <div class="prt-td prt-td-status">
                        <span class="prt-status-badge"
                          [ngClass]="expired(row) ? 'prt-status-expired' : 'prt-status-' + (getCatalogDisplayStatus(row.status) || 'draft')">
                          {{ expired(row) ? ('common.expired' | translate) : (getCatalogDisplayStatus(row.status) | titlecase) }}
                        </span>
                      </div>
                    </div>
                  </ng-container>
                  <ng-template #emptyCatalogs>
                    <div class="prt-empty-state" *ngIf="!catalogSearchInput.value; else noSearchMatch">
                      <img src="assets/icones/Illustrations.svg" alt="" class="prt-empty-illustration">
                      <span class="prt-empty-text">{{ 'companies.orders_tab.not_enough_data' | translate }}</span>
                    </div>
                    <ng-template #noSearchMatch>
                      <div class="prt-empty-state prt-empty-search">
                        <span class="prt-empty-text">{{ 'customers.preference_tab.no_catalogs_search' | translate }}</span>
                      </div>
                    </ng-template>
                  </ng-template>
                </div>
              </div>
            </div>

            <!-- <div class="prt-divider"></div> -->

            <!-- ===== Product Preferences ===== -->
            <!-- <span class="prt-section-title">{{ 'customers.preference_tab.product_preferences' | translate }}</span> -->

            <!--
            <form [formGroup]="form" class="prt-pref-form">

              ===== Whitelisted Products =====
              <div class="prt-pref-row prt-pref-row-curated">
                <div class="prt-pref-label-col">
                  <span class="prt-pref-label">{{ 'customers.preference_tab.whitelisted_products' | translate }}</span>
                  <img src="assets/icones/info-cc.svg" alt="" class="prt-info-icon" />
                </div>
                <div class="prt-pref-field-col">
                  <span class="prt-field-label">{{ 'customers.preference_tab.brands_or_categories' | translate }}</span>

                  <div class="prt-select-box" *ngIf="favorit_brands.length === 0 && whitelistedCategories.length === 0">
                    <input
                      type="text"
                      class="prt-inline-select-input"
                      [placeholder]="'customers.preference_tab.select_brand_placeholder' | translate"
                      formControlName="brandControl"
                      [matAutocomplete]="autoFavoritBrand"
                      (blur)="onChipInputBlur('brand')"
                    />
                    <img src="assets/icones/chevron-down.svg" alt="" class="prt-chevron" />
                  </div>
                  <div class="prt-chips-box" *ngIf="favorit_brands.length > 0 || whitelistedCategories.length > 0">
                    <span class="prt-chip-tag prt-chip-brand" *ngFor="let brand of favorit_brands">
                      <span class="prt-chip-type-label">Brand</span>{{ brand.name }}
                      <button type="button" class="prt-chip-close"
                        *appHasPermission="{ module: 'company', action: 'edit' }"
                        (click)="cancelFavoritBrand(brand.id)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                    <span class="prt-chip-tag prt-chip-category" *ngFor="let cat of whitelistedCategories">
                      <span class="prt-chip-type-label">Category</span>{{ cat.name }}
                      <button type="button" class="prt-chip-close"
                        *appHasPermission="{ module: 'company', action: 'edit' }"
                        (click)="cancelWhitelistCategory(cat.id)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                    <input
                      *appHasPermission="{ module: 'company', action: 'edit' }"
                      type="text"
                      class="prt-inline-chip-input"
                      [placeholder]="'customers.preference_tab.add_brand_placeholder' | translate"
                      formControlName="brandControl"
                      [matAutocomplete]="autoFavoritBrand"
                      (blur)="onChipInputBlur('brand')"
                    />
                  </div>
                  <mat-autocomplete #autoFavoritBrand="matAutocomplete">
                    <mat-optgroup label="Brands" *ngIf="filteredBrands$ | async as brands">
                      <mat-option *ngFor="let brand of brands" [value]="brand.name" (click)="onFavoritBrandSelected(brand)">
                        {{ brand.name }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-autocomplete>

                  <div class="prt-curated-cat-row">
                    <input
                      *appHasPermission="{ module: 'company', action: 'edit' }"
                      type="text"
                      class="prt-inline-chip-input prt-curated-cat-input"
                      [placeholder]="'customers.preference_tab.add_category_placeholder' | translate"
                      formControlName="whitelistCategoryControl"
                      [matAutocomplete]="autoWhitelistCat"
                      (blur)="onChipInputBlur('whitelistCategory')"
                    />
                    <mat-autocomplete #autoWhitelistCat="matAutocomplete">
                      <mat-optgroup label="Categories" *ngIf="filteredWhitelistCategories$ | async as cats">
                        <mat-option *ngFor="let cat of cats" [value]="cat.name" (click)="onWhitelistCategorySelected(cat)">
                          {{ cat.name }}
                        </mat-option>
                      </mat-optgroup>
                    </mat-autocomplete>
                  </div>

                  <button
                    *ngIf="favorit_brands.length > 0 || whitelistedCategories.length > 0"
                    type="button"
                    class="prt-view-resolved-btn"
                    (click)="openResolvedProductsDialog('whitelist')">
                    {{ 'customers.preference_tab.view_resolved_products' | translate }}
                    <span class="prt-resolved-count" *ngIf="whitelistResolvedProducts.length > 0">
                      ({{ whitelistResolvedProducts.length }}{{ whitelistTruncated ? '+' : '' }})
                    </span>
                  </button>
                </div>
              </div>

              ===== Blacklisted Products =====
              <div class="prt-pref-row prt-pref-row-curated">
                <div class="prt-pref-label-col">
                  <span class="prt-pref-label">{{ 'customers.preference_tab.blacklisted_products' | translate }}</span>
                  <img src="assets/icones/info-cc.svg" alt="" class="prt-info-icon" />
                </div>
                <div class="prt-pref-field-col">
                  <span class="prt-field-label">{{ 'customers.preference_tab.brands_or_categories' | translate }}</span>

                  <div class="prt-select-box" *ngIf="blacklist_brands.length === 0 && blacklistedCategories.length === 0">
                    <input
                      type="text"
                      class="prt-inline-select-input"
                      [placeholder]="'customers.preference_tab.select_brand_placeholder' | translate"
                      formControlName="blacklistBrandControl"
                      [matAutocomplete]="autoBlacklistBrand"
                      (blur)="onChipInputBlur('blacklistBrand')"
                    />
                    <img src="assets/icones/chevron-down.svg" alt="" class="prt-chevron" />
                  </div>
                  <div class="prt-chips-box" *ngIf="blacklist_brands.length > 0 || blacklistedCategories.length > 0">
                    <span class="prt-chip-tag prt-chip-brand" *ngFor="let brand of blacklist_brands">
                      <span class="prt-chip-type-label">Brand</span>{{ brand.name }}
                      <button type="button" class="prt-chip-close"
                        *appHasPermission="{ module: 'company', action: 'edit' }"
                        (click)="cancelBlackListBrand(brand.id)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                    <span class="prt-chip-tag prt-chip-category" *ngFor="let cat of blacklistedCategories">
                      <span class="prt-chip-type-label">Category</span>{{ cat.name }}
                      <button type="button" class="prt-chip-close"
                        *appHasPermission="{ module: 'company', action: 'edit' }"
                        (click)="cancelBlacklistCategory(cat.id)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                    <input
                      *appHasPermission="{ module: 'company', action: 'edit' }"
                      type="text"
                      class="prt-inline-chip-input"
                      [placeholder]="'customers.preference_tab.add_brand_placeholder' | translate"
                      formControlName="blacklistBrandControl"
                      [matAutocomplete]="autoBlacklistBrand"
                      (blur)="onChipInputBlur('blacklistBrand')"
                    />
                  </div>
                  <mat-autocomplete #autoBlacklistBrand="matAutocomplete">
                    <mat-optgroup label="Brands" *ngIf="filteredBlacklistBrands$ | async as brands">
                      <mat-option *ngFor="let brand of brands" [value]="brand.name" (click)="onBlackListBrandSelected(brand)">
                        {{ brand.name }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-autocomplete>

                  <div class="prt-curated-cat-row">
                    <input
                      *appHasPermission="{ module: 'company', action: 'edit' }"
                      type="text"
                      class="prt-inline-chip-input prt-curated-cat-input"
                      [placeholder]="'customers.preference_tab.add_category_placeholder' | translate"
                      formControlName="blacklistCategoryControl"
                      [matAutocomplete]="autoBlacklistCat"
                      (blur)="onChipInputBlur('blacklistCategory')"
                    />
                    <mat-autocomplete #autoBlacklistCat="matAutocomplete">
                      <mat-optgroup label="Categories" *ngIf="filteredBlacklistCategories$ | async as cats">
                        <mat-option *ngFor="let cat of cats" [value]="cat.name" (click)="onBlacklistCategorySelected(cat)">
                          {{ cat.name }}
                        </mat-option>
                      </mat-optgroup>
                    </mat-autocomplete>
                  </div>

                  <button
                    *ngIf="blacklist_brands.length > 0 || blacklistedCategories.length > 0"
                    type="button"
                    class="prt-view-resolved-btn"
                    (click)="openResolvedProductsDialog('blacklist')">
                    {{ 'customers.preference_tab.view_resolved_products' | translate }}
                    <span class="prt-resolved-count" *ngIf="blacklistResolvedProducts.length > 0">
                      ({{ blacklistResolvedProducts.length }}{{ blacklistTruncated ? '+' : '' }})
                    </span>
                  </button>
                </div>
              </div>

              <div class="prt-pref-row">
                <div class="prt-pref-label-col">
                  <span class="prt-pref-label">{{ 'customers.preference_tab.groups_label' | translate }}</span>
                  <img src="assets/icones/info-cc.svg" alt="" class="prt-info-icon" />
                </div>
                <div class="prt-pref-field-col">
                  <span class="prt-field-label">{{ 'customers.preference_tab.include_into_group' | translate }}</span>
                  <div class="prt-select-box" *ngIf="preferenceGroupes.length === 0">
                    <input
                      type="text"
                      class="prt-inline-select-input"
                      [placeholder]="'common.select' | translate"
                      formControlName="groupeControl"
                      [matAutocomplete]="autoGroupe"
                      (blur)="onChipInputBlur('groupe')"
                    />
                    <img src="assets/icones/chevron-down.svg" alt="" class="prt-chevron" />
                  </div>
                  <div class="prt-chips-box" *ngIf="preferenceGroupes.length > 0">
                    <span class="prt-chip-tag" *ngFor="let group of preferenceGroupes">
                      {{ group.name }}
                      <button type="button" class="prt-chip-close"
                        *appHasPermission="{ module: 'company', action: 'edit' }"
                        (click)="cancelGroupe(group.id)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </span>
                    <input
                      *appHasPermission="{ module: 'company', action: 'edit' }"
                      type="text"
                      class="prt-inline-chip-input"
                      [placeholder]="'customers.preference_tab.add_group_placeholder' | translate"
                      formControlName="groupeControl"
                      [matAutocomplete]="autoGroupe"
                      (blur)="onChipInputBlur('groupe')"
                    />
                  </div>
                  <mat-autocomplete #autoGroupe="matAutocomplete">
                    <ng-container *ngIf="filteredGroupes$ | async as groups">
                      <mat-option *ngFor="let group of groups" [value]="group.name" (click)="onGroupeSelected(group)">
                        {{ group.name }}
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </div>
              </div>

            </form>
            -->

          </div>
        </ng-container>

        <!-- Resolved Products Dialog Template -->
        <ng-template #resolvedProductsDialogTpl>

          <!-- Accent stripe -->
          <div class="rp-accent-bar"
               [class.rp-accent-whitelist]="activeResolvedType === 'whitelist'"
               [class.rp-accent-blacklist]="activeResolvedType === 'blacklist'">
          </div>

          <!-- Header -->
          <div class="rp-dialog-header">
            <div class="rp-header-left">
              <div class="rp-header-icon"
                   [class.rp-icon-whitelist]="activeResolvedType === 'whitelist'"
                   [class.rp-icon-blacklist]="activeResolvedType === 'blacklist'">
                <mat-icon>{{ activeResolvedType === 'whitelist' ? 'check_circle' : 'block' }}</mat-icon>
              </div>
              <div class="rp-header-text">
                <span class="rp-dialog-title">{{ activeResolvedTitle }}</span>
                <span class="rp-dialog-subtitle">
                  <ng-container *ngIf="activeResolvedProducts.length > 0">
                    {{ activeResolvedProducts.length }}{{ activeResolvedTruncated ? '+' : '' }}
                    {{ activeResolvedProducts.length === 1 ? ('customers.preference_tab.product_resolved' | translate) : ('customers.preference_tab.products_resolved' | translate) }}
                  </ng-container>
                  <ng-container *ngIf="activeResolvedProducts.length === 0">
                    {{ 'customers.preference_tab.no_products_resolved' | translate }}
                  </ng-container>
                </span>
              </div>
            </div>
            <button type="button" class="rp-dialog-close" [mat-dialog-close]="">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <!-- Selection summary -->
          <div class="rp-selection-summary"
               *ngIf="activeResolvedSelectionBrands.length > 0 || activeResolvedSelectionCategories.length > 0">
            <span class="rp-selection-label">{{ 'common.from' | translate }}</span>
            <span class="rp-sel-chip rp-sel-brand" *ngFor="let b of activeResolvedSelectionBrands">
              {{ b.name }}
            </span>
            <span class="rp-sel-chip rp-sel-cat" *ngFor="let c of activeResolvedSelectionCategories">
              {{ c.name }}
            </span>
          </div>

          <!-- Truncation notice -->
          <div class="rp-truncated-notice" *ngIf="activeResolvedTruncated">
            <mat-icon class="rp-truncated-icon">info_outline</mat-icon>
            {{ 'customers.preference_tab.showing_first_200' | translate }}
          </div>

          <!-- Search bar -->
          <div class="rp-search-row" *ngIf="activeResolvedProducts.length > 0">
            <mat-icon class="rp-search-icon">search</mat-icon>
            <input
              type="text"
              class="rp-search-input"
              [placeholder]="'customers.preference_tab.filter_products_placeholder' | translate"
              [value]="rpSearchQuery"
              (input)="rpSearchQuery = $any($event.target).value"
              autocomplete="off"
            />
            <button *ngIf="rpSearchQuery" type="button" class="rp-search-clear" (click)="rpSearchQuery = ''">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <!-- Product list -->
          <mat-dialog-content class="rp-dialog-body">
            <ng-container *ngIf="activeFilteredProducts.length > 0; else rpEmpty">
              <div class="rp-product-item" *ngFor="let p of activeFilteredProducts; let i = index">
                <span class="rp-product-index">{{ i + 1 }}</span>
                <div class="rp-product-img-wrap">
                  <img *ngIf="p.image"
                       [src]="p.image"
                       class="rp-product-img"
                       (error)="onImageError($event)"
                       alt="" />
                  <div *ngIf="!p.image" class="rp-product-img-placeholder">
                    <mat-icon>inventory_2</mat-icon>
                  </div>
                </div>
                <div class="rp-product-info">
                  <span class="rp-product-name">{{ p.name || '—' }}</span>
                  <span class="rp-product-code" *ngIf="p.code">{{ p.code }}</span>
                </div>
              </div>
            </ng-container>

            <ng-template #rpEmpty>
              <div class="rp-empty">
                <img src="assets/icones/no-product-illustration.svg" alt="" class="rp-empty-img" />
                <span *ngIf="rpSearchQuery; else rpEmptyDefault">
                  {{ 'customers.preference_tab.no_products_match' | translate }} "<strong>{{ rpSearchQuery }}</strong>"
                </span>
                <ng-template #rpEmptyDefault>
                  {{ 'customers.preference_tab.no_products_for_selection' | translate }}
                </ng-template>
              </div>
            </ng-template>
          </mat-dialog-content>

        </ng-template>

        <!-- Activity Tab -->
        <ng-container *ngIf="activeTab === 'activity'">
          <div class="act-container">

            <!-- Header -->
            <div class="act-header">
              <span class="act-title">{{ 'customers.activity_tab.activity_history' | translate }}</span>
            </div>

            <!-- Populated state -->
            <ng-container *ngIf="customer?.activities?.length; else activityEmpty">

              <!-- Activity Groups by Month -->
              <div class="act-groups">
                <div class="act-group" *ngFor="let group of activityGroups; let gi = index">

                  <!-- Month Header -->
                  <div class="act-month-header" (click)="toggleActivityGroup(gi)">
                    <span class="act-month-label">{{ group.label }}</span>
                    <img src="assets/icones/chevron-up.svg" alt=""
                      class="act-month-chevron"
                      [ngClass]="{ 'act-chevron-collapsed': group.collapsed }" />
                  </div>

                  <!-- Activity Cards -->
                  <ng-container *ngIf="!group.collapsed">
                    <div class="act-card" *ngFor="let activity of group.items"
                      [ngClass]="getActivityBgClass(activity.activity)">
                      <div class="act-card-inner">
                        <div class="act-card-left">
                          <img [src]="getActivityIcon(activity.activity)" alt="" class="act-card-icon" />
                          <div class="act-card-text">
                            <span class="act-actor">{{ activity.user }}</span>
                            <span class="act-action">{{ 'activity.' + activity.activity | translate }}</span>
                            <ng-container *ngIf="activity.details">
                              <img src="assets/icones/catalog-link-icon.svg" alt="" class="act-catalog-icon" />
                              <span class="act-detail-link">{{ activity.details }}</span>
                            </ng-container>
                          </div>
                        </div>
                        <span class="act-timestamp">{{ activity.date | date: 'dd/MM/yyyy' }}</span>
                      </div>
                    </div>
                  </ng-container>

                </div>
              </div>

            </ng-container>

            <!-- Empty state -->
            <ng-template #activityEmpty>
              <div class="act-empty-state">
                <img src="assets/icones/no-orders.svg" alt="" class="act-empty-illustration" />
                <p class="act-empty-text">{{ 'companies.orders_tab.not_enough_data' | translate }}</p>
              </div>
            </ng-template>

          </div>
        </ng-container>

        <!-- Location Tab — delegated to LocationMapComponent (H2 refactor) -->
        <app-location-map
          [hidden]="activeTab !== 'location'"
          [locations]="allLocationsForTable"
          [customerName]="customer?.name || ''"
          [active]="activeTab === 'location'"
          (addLocation)="addLocations()"
          (editLocation)="editLocationDialog($event)"
          (deleteLocation)="confirmDeleteLocationRow($event)">
        </app-location-map>

      </div>
    </div>

    <!-- Right Panel (Tabs: Details, Contact) -->
    <div class="right-panel">
      <div class="tabs">
        <div class="tab" [class.active]="rightPanelTab === 'details'" (click)="setRightPanelTab('details')">
          {{ "inventory.details" | translate }}
        </div>
        <div class="tab" [class.active]="rightPanelTab === 'contact'" (click)="setRightPanelTab('contact')">
          {{ "companies.contacts" | translate }}
        </div>
      </div>

      <div class="tab-content-wrapper">
        <app-customer-informations
          [customer]="customer"
          [currentLocation]="currentLocation"
          [contacts_information]="contacts_information"
          [otherLocations]="otherLocations"
          [currencies]="currencies"
          [paymentTerms]="paymentTerms"
          [groupes]="groupes"
          [tags]="tags"
          [categories]="categories"
          [blacklist_brands]="blacklist_brands"
          [favorit_brands]="favorit_brands"
          [selectedFiles]="selectedFiles"
          [objectCustomFields]="objectCustomFields"
          [currentLanguage]="currentLanguage"
          [visibleTab]="rightPanelTab"
          [traditionalContactsEnabled]="featureFlagService.traditionalContactsEnabled"
          [aiEmailsErp]="(aiEmailsErp$ | async) ?? []"
          [aiEmailsVolta]="(aiEmailsVolta$ | async) ?? []"
          [locationEmailsErp]="(locationEmailsErp$ | async) ?? []"
          [locationEmailsVolta]="(locationEmailsVolta$ | async) ?? []"
          [isLoadingEmails]="((isLoadingEmails$ | async) || (isLoadingLocationEmails$ | async)) ?? false"
          [emailMutationError]="(emailMutationError$ | async) || (locationEmailMutationError$ | async)"
          (addContactClicked)="addContacts($event)"
          (editFilesClicked)="editFiles(selectedFiles)"
          (editCustomFieldsClicked)="editCustomFields()"
          (openLocationClicked)="openLocation($event)"
          (addLocationsClicked)="addLocations()"
          (editLocationClicked)="editLocationDialog($event)"
          (downloadFileClicked)="download($event.data, $event.filename, $event.content_type)"
          (previewFileClicked)="preview($event.data, $event.content_type)"
          (addEmailClicked)="onAddEmailClicked($event)"
          (editEmailClicked)="onEditEmailClicked($event)"
          (deleteEmailClicked)="onDeleteEmailClicked($event)"
        ></app-customer-informations>
      </div>
    </div>
  </div>

  <!-- Insert Catalogs View (full page) -->
  <ng-container *ngIf="currentForm === 'insertCatalogs'">
    <app-inserting-catalogs
      [selectedCatalogsO]="selectedCatalogs"
      [currentCustomDiscount]="currentCustomDiscount"
      (saveCatalogs)="onSaveCatalogs($event)"
      (cancelCatalogs)="cancel()"
    ></app-inserting-catalogs>
  </ng-container>
</div>

<!-- Loading State -->
<div class="loading-container" *ngIf="!isLoaded">
  <app-loader></app-loader>
</div>
